import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaMoneyBillWave, FaClipboardList, FaUsers, FaFileUpload, FaBell, FaUserPlus, FaRunning, FaImages, FaCreditCard, FaBuilding, FaCalendarAlt } from 'react-icons/fa';
import { MdSportsSoccer } from 'react-icons/md';
import Header from './Header';
import { Link } from 'react-router-dom';
import { authService } from './services/authService';
import './scss/admin.scss';

function Admin() {
  const navigate = useNavigate();
  const isSuperAdmin = sessionStorage.getItem('player_id') === '1';
  
  // Check if the team has training enabled
  const teamHasTraining = sessionStorage.getItem('selected_team_has_training');
  const hasTraining = teamHasTraining === 'true' || teamHasTraining === '1';
  const teamType = sessionStorage.getItem('selected_team_type');
  const showPayments = teamType !== 'squad';

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div className="Admin container">
        <Header />
        <div>
          <h1>Admin Dashboard</h1>
        </div>
        {hasTraining && (
          <div className="stats-container dashboard-nav">
            <div className="stats-column full-width" onClick={() => handleNavigate('/createTrainingSession')}>
              <FaRunning size={50} />
              <p>Create Training Session</p>
            </div>
          </div>
        )}
        <div className="stats-container dashboard-nav">
          <div className="stats-column" onClick={() => handleNavigate('/players')}>
            <FaUsers size={50} />
            <p>Manage Players</p>
          </div>
          { authService.isSuperAdmin() && (
            <div className="stats-column" onClick={() => handleNavigate('/team-directory')}>
              <FaBuilding size={50} />
              <p>Team Directory</p>
            </div>
          )}
        </div>
        {(showPayments || authService.isSuperAdmin()) && (
          <div className="stats-container dashboard-nav">
            {showPayments && (
              <div className="stats-column" onClick={() => handleNavigate('/payments')}>
                <FaFileUpload size={50} />
                <p>Payments</p>
              </div>
            )}
            {authService.isSuperAdmin() && (
              <div className="stats-column" onClick={() => handleNavigate('/fees')}>
                <FaCreditCard size={50} />
                <p>Fees</p>
              </div>
            )}
          </div>
        )}
        <div className="stats-container dashboard-nav">
          <div className="stats-column" onClick={() => handleNavigate('/season-management')}>
            <FaCalendarAlt size={50} />
            <p>Season Management</p>
          </div>
        </div>
        {isSuperAdmin && (
          <div className="stats-container dashboard-nav">
            <div className="stats-column" onClick={() => handleNavigate('/story-manager')}>
              <FaImages size={50} />
              <p>Stories Manager</p>
            </div>
          </div>
        )}
        { authService.isSuperAdmin() && (
          <>
            <div className="stats-container dashboard-nav">
              <div className="stats-column" onClick={() => handleNavigate('/activity-log')}>
                <FaClipboardList size={50} />
                <p>Activity Log</p>
              </div>
            </div>
            <div className="stats-container dashboard-nav">
              <div className="stats-column" onClick={() => handleNavigate('/register-team')}>
                <FaUserPlus size={50} />
                <p>Register Team</p>
              </div>
              <div className="stats-column" onClick={() => handleNavigate('/assign-manager')}>
                <FaUsers size={50} />
                <p>Assign Manager / Coach</p>
              </div>
            </div>
            <div className="stats-container dashboard-nav">
              <div className="stats-column" onClick={() => handleNavigate('/stripe-admin')}>
                <FaCreditCard size={50} />
                <p>Stripe Subscriptions</p>
              </div>
            </div>
          </>
        )}
      
        {/* <div className="admin-controls">
          <button onClick={() => navigate('/player-matches')} className="admin-button">
            <FaUsers />
            Player Matches & Payments
          </button>
        </div> */}
      </div>
  );
}

export default Admin; 